// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1qdJI","colMaxWidth":"Table_colMaxWidth__1a0vu"};